(function () {
	'use strict';
	$(document).ready(function () {
		// responsive-image module zoomable feature
		document.querySelectorAll('.module.responsive-image .image-container.zoomable .desktop-image').forEach((containerElement) => {
			const popupContainer = document.createElement('div');
			popupContainer.classList.add('popup-image-container');
			const clonedImg = containerElement.parentElement.querySelector('.popup-image img').cloneNode(true);
			clonedImg.classList.add('popup-image');
			popupContainer.appendChild(clonedImg);

			const removePopupContainer = () => {
				$(popupContainer).fadeOut(() => {
					popupContainer.remove();
				});
			};
			popupContainer.addEventListener('click', removePopupContainer);

			const mediaQuery = window.matchMedia('(min-width: 768px)');
			mediaQuery.addEventListener('change', () => {
				if (!mediaQuery.matches) {
					removePopupContainer();
				}
			})
			containerElement.querySelector('img').addEventListener('click', () => {
				if (mediaQuery.matches) {
					document.body.appendChild(popupContainer);
					$(popupContainer).fadeIn();
				}
			})
		});

		//Tooltipster

		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

		//gallery module
		document.querySelectorAll('.gallery').forEach(function (gallery) {

			new SimpleLightbox(gallery.querySelectorAll('a'), {
				showCounter: false,
				overlayOpacity: 0,
				scrollZoom: false,
				closeText: '',
				navText: ['', '']
			});
		});

		if (window.innerWidth > 768) {
			document.querySelector('.subpage').classList.remove('scrolled');
			const showAnim = gsap.to('header', {
				yPercent: -200,
				paused: true,
				ease: 'easeOut'
			});

			const url = document.location.toString();
			let flag = false;
			if (url.match('#')) flag = true;
			const titleHeight = document.querySelector('h1')?.offsetHeight ?? 0;
			let summaryHeight = titleHeight + 230;
			gsap.to('.side-content', { top: summaryHeight, opacity: 1, delay: 0, duration: 0 });

			ScrollTrigger.create({
				target: 'body',
				start: () => `top top`,
				end: 'bottom top',
				markers: false,
				onUpdate: (self) => {
					self.direction === -1 ? summaryHeight = titleHeight + 230 : summaryHeight = titleHeight + 80;
					if ($('.header.open').length < 1) {
						self.direction === -1 ? showAnim.reverse() : showAnim.play();
					}
					self.direction === -1 ? document.querySelector('.subpage').classList.remove('scrolled') : document.querySelector('.subpage').classList.add('scrolled');
					gsap.to('.side-content', {
						top: summaryHeight,
						opacity: 1,
						delay: 0,
						duration: 0
					});
				}
			});
			if (document.querySelector('.top') !== null) {
				let isOpen = false;
				document.querySelector('.menu-toggle').addEventListener('click', () => {
					isOpen = !!$('.menu-overlay').hasClass('open');
				});
				ScrollTrigger.create({
					trigger: '.top',
					start: () => `+=${150 - titleHeight / 2} top`,
					markers: false,
					end: "bottom top",
					onEnter: () => {
						if (flag || isOpen) {
							flag = false;
							isOpen = false;
						} else {
							gsap.to(window, { scrollTo: ".content", duration: .95, });
						}
					}
				});
			}

			if (url.match('#')) {
				const sectionId = $('#' + url.split('#')[1]);
				setTimeout(function () {
					$("html, body").animate({
						scrollTop: $(sectionId).offset().top - 200
					}, 1000);
				}, 100);
			}
		}
	});
}(jQuery));
